import { Save } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { Button, Spinner } from '@ifs-gcp/components';

import { useAuditStore } from '@/store/auditStore';

import styles from './save-audit-action.module.scss';

type SaveAuditActionProps = {
  isSaving: boolean;
  onSaveAudit: () => void;
};

export const SaveAuditAction = ({ isSaving, onSaveAudit }: SaveAuditActionProps) => {
  const { t } = useTranslation();
  const isActionPending = useAuditStore((state) => state.isActionPending);

  return (
    <Button
      variant="contained"
      color="secondary"
      startIcon={<Save />}
      onClick={() => onSaveAudit()}
      disabled={isActionPending}
      className={styles.saveButton}
      classes={{
        startIcon: isSaving ? styles.hiddenIcon : '',
      }}
    >
      {isSaving ? (
        <div className={styles.spinnerBox}>
          <Spinner size={16} />
          <p>{t('actions.save')}</p>
        </div>
      ) : (
        t('actions.save')
      )}
    </Button>
  );
};
